module.exports = __webpack_public_path__ + "static/expert-discover-d5a7c5d7e88b3756ca1d0532fa121747.svg";